import { render } from "./IndexDropdown.vue?vue&type=template&id=db189ef0&scoped=true"
import script from "./IndexDropdown.vue?vue&type=script&lang=js"
export * from "./IndexDropdown.vue?vue&type=script&lang=js"

import "./IndexDropdown.vue?vue&type=style&index=0&id=db189ef0&scoped=true&lang=css"

import exportComponent from "C:\\Master\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db189ef0"]])

export default __exports__